/**
 * @fileoverview Ant Design DatePicker locale helper for NotificationForm.
 * @module pages/notificationForm/notificationFormLocale
 */
import locale from "antd/es/date-picker/locale/es_ES";

/** Returns the antd DatePicker locale for the active i18n language. */
export const getNotificationFormLocale = (language) => {
  switch (language) {
    case "es":
      return locale;
    case "en":
      return require("antd/es/date-picker/locale/en_US").default;
    case "fr":
      return require("antd/es/date-picker/locale/fr_FR").default;
    default:
      return locale;
  }
};
